angular.module('bbl.module.dashboard.directives', [])
  .directive('toggleButton', [directiveToggleButton])
  .directive('tileLink', ['$timeout', directiveTileLink])
  .directive('toastMessage', ['$timeout', directiveToastMessage])
  .directive('feedbackForm', ['$http', 'Toast', feedbackForm])
  .filter('partition', [partitionFilter]);

function directiveToggleButton() {
  return {
    restrict: 'E',
    require:"ngModel",
    link: function(scope, element, attrs, ngModel) {
      element.bind('click', function(ev) {
        scope.$apply(function() {
          ngModel.$setViewValue(!ngModel.$modelValue);
        });
      });
      if(attrs.toggle !== undefined && attrs.toggle == 'tooltip') {
        element.tooltip({
          viewport: 'body'
        });
      }
      scope.$watch(function() {
        return ngModel.$modelValue;
      }, function(newValue) {
        if(newValue) {
          element.find('.toggle-button-selected').show();
          element.find('.toggle-button-default').hide();
          element.removeClass(attrs.default).addClass(attrs.selected);
        } else {
          element.find('.toggle-button-selected').hide();
          element.find('.toggle-button-default').show();
          element.removeClass(attrs.selected).addClass(attrs.default);
        }
      });
    }
  };
}

function directiveTileLink($timeout) {
  return {
    restrict: 'E',
    scope: {
      bridge: '=',
      selectedstart: '=',
      isactivebridge: '='
    },
    link:function(scope, element, attrs) {
      element.bind('click', function(ev) {
        var wrapper = element.closest('.tile-slider-wrapper');
        // ev.stopPropagation();
        wrapper.find('.tile-stats').removeClass(attrs.selected).addClass(attrs.default);
        element.addClass(attrs.selected);
        element.removeClass(attrs.default);
      });
      var inProgress = scope.bridge.in_progress_conferences_caller_count > 0;
      if(inProgress) {
        element.addClass(attrs.inprogress);
      }
      if(scope.isactivebridge) {
        element.addClass(attrs.selected);
      }
      if(scope.selectedstart === false && scope.bridge.idx === 0 && !element.hasClass(attrs.selected)) {
        $timeout(function(){
          element.click();
        });
      }

      if(inProgress && scope.selectedstart === scope.bridge.id && !element.hasClass(attrs.selected)) {
        $timeout(function(){
          element.click();
        });
      }
    }
  };
}

function directiveToastMessage($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      $timeout(function(){
        element.addClass('animate-alert');
      }, 150);

      $timeout(function(){
        element.remove();
      }, 3000);
    }
  };
}

function partitionFilter() {
  var localCache = {};

  var filter = function(input, size) {

    if (!input || !size) {
      return input;
    }


    var args = [].slice.call(arguments);

    var key = JSON.stringify(args);

    if (localCache.hasOwnProperty(key)) {
      return localCache[key];
    }

    var newArr = [];

    for (var i = 0; i < input.length; i+= size) {
      newArr.push(input.slice(i, i+size));
    }

    localCache[key] = newArr;
    return localCache[key];
  };

  return filter;
}

function feedbackForm($http, Toast) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      bridge: '='
    },
    template: ''+
    '<form name="commentform" novalidate="novalidate" autocomplete="off" ng-init="submited=false">'+
        "<label>{{'We strive for connection perfection'|translate}}.</label>"+
        '<div class="input-group">'+
            '<textarea type="text" ng-minlength="3" required="true" class="form-control" placeholder="{{\'Comment on the quality of this call\'|translate}}" name="commentbox" ng-model="commentbox" ng-init="noRows=1" rows="{{noRows}}" ng-focus="submited=false;noRows=3" ng-blur="noRows=1" style="resize: none; overflow: hidden;"></textarea>'+
            '<span class="input-group-btn vtop">'+
                '<button class="btn" ng-class="{\'btn-primary\': !commentform.commentbox.$invalid, \'btn-warn\': commentform.commentbox.$invalid}" type="button" ng-click="(submited=true) &amp;&amp; !commentform.commentbox.$invalid &amp;&amp; submitComment($event, commentbox)">{{\'Send\'|translate}}</button>'+
            '</span>'+
        '</div>'+
        '<div class="wrong-number" ng-show="commentform.commentbox.$invalid &amp;&amp; submited">{{\'You must enter a comment\'|translate}}</div>'+
        "<p class=\"text-muted\">{{'Is the current call quality up to par? Comment on it here and we\\'ll investigate immediately.'|translate}}</p>"+
    '</form>',
    link: function(scope, element) {
      scope.submitComment = function ($event, comment) {
        var data = $.param({comment: comment});

        $http.post('/bridges/api/v1/quality_comment/'+scope.bridge+'/?format=json', data,
          {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        ).then(function() {
          scope.submited = false;
          scope.commentbox = '';
          Toast.notify("{{'Your comment has been submited.'|translate}}");
        }, function() {
          Toast.error("{{'Something went wrong performing this action'|translate}}. {{'Please try again!'|translate}}");
        });
      };
    }
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard.directives.js
 ** module id = 323
 ** module chunks = 0
 **/